import React from 'react';
import sizeDepth from 'assets/images/size/depth.svg';
import ShelvesHeightSelector from 'containers/Ribbon/ShelvesRibbon/ShelvesHeightSelector/ShelvesHeightSelector';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import ActionShelfRibbonSection from 'containers/Ribbon/ShelvesRibbon/ActionShelfRibbonSection';
import ShelfCompositionSelector from 'containers/Ribbon/ShelvesRibbon/ShelfCompositionSelector';
import { useTranslation } from 'react-i18next';
import MobileMenu from 'components/MobileMenu';
import ColorsMobilePanel from 'containers/PanesPanel/ColorsMobile';
import HandlesPanel from 'containers/HandlesPanel';
import IntermediateShelfPanel from 'containers/IntermediateShelfPanel';
import DrawersPanel from 'containers/DrawersPanel';
import PlatePanel from 'containers/PlatePanel';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/Ribbon/ShelvesRibbon/types';
import {
  makeSelectHaveOneDoor,
  makeSelectHaveOneDrawer,
  makeSelectMarkHeight,
} from 'containers/Ribbon/ShelvesRibbon/selectors';
import { makeSelectFullDrawersSelection } from 'containers/DrawersPanel/selectors';
import { useSelector } from 'react-redux';
import { makeSelectActivePanel } from 'containers/Configurator/selectors/general';
import { makeSelectCanAddIs } from 'containers/Ribbon/ShelvesRibbon/ColorsSection/selectors';
import { makeSelectRibbonIsMobileMenuOpen } from '../selectors';
import { ActivePanel } from '../../Configurator/constants/general';

type Selection =
  | 'height'
  | 'action'
  | 'composition'
  | 'doors'
  | 'handles'
  | 'sides'
  | 'plate'
  | 'intermediatesShelves'
  | 'drawers';

interface Props {
  shelvesSelected: Shelf[];
  shelvesCabinet: Shelf[];
  commonHeight: number | undefined;
  updateSelectedHeight: any;
}

interface StateProps {
  haveOneDrawer: boolean;
  haveOneDoor: boolean;
  isAllSelectionDrawers: boolean;
  mobilePanelOpen: ActivePanel | undefined;
  canAddIs: boolean;
  isMobileMenuOpen: boolean;
  marksHeight: any[];
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  haveOneDrawer: makeSelectHaveOneDrawer(),
  haveOneDoor: makeSelectHaveOneDoor(),
  isAllSelectionDrawers: makeSelectFullDrawersSelection(),
  mobilePanelOpen: makeSelectActivePanel(),
  canAddIs: makeSelectCanAddIs(),
  isMobileMenuOpen: makeSelectRibbonIsMobileMenuOpen(),
  marksHeight: makeSelectMarkHeight(),
});

function MobileMenuShelves(props: Props) {
  const {
    shelvesSelected,
    shelvesCabinet,
    commonHeight,
    updateSelectedHeight,
  } = props;
  const { t } = useTranslation();

  const {
    haveOneDrawer,
    haveOneDoor,
    isAllSelectionDrawers,
    mobilePanelOpen,
    canAddIs,
    isMobileMenuOpen,
    marksHeight,
  } = useSelector(stateSelector);

  const list = [{ name: t('Height'), key: 'height' }];
  // if (shelvesCabinet.length > 1 && shelvesSelected.length === 1) {
  //   list.push({ name: t('Shelf'), key: 'action' });
  // }
  list.push({ name: t('Composition'), key: 'composition' });

  if (haveOneDoor) {
    list.push({ name: t('Doors'), key: 'doors' });
  }
  if (haveOneDrawer) {
    list.push({ name: t('Drawers'), key: 'drawers' });
  }
  if (haveOneDoor || haveOneDrawer) {
    list.push({ name: t('Handles'), key: 'handles' });
  }
  list.push({ name: t('Plate'), key: 'plate' });
  list.push({ name: t('Sides/backpane'), key: 'sides' });

  if (!isAllSelectionDrawers && canAddIs) {
    list.push({
      name: t('Intermediates Shelves'),
      key: 'intermediatesShelves',
    });
  }

  function cabinetEdit(selected: Selection) {
    switch (selected) {
      case 'height':
        return (
          <ShelvesHeightSelector
            commonHeight={commonHeight}
            icon={sizeDepth}
            handleInput={updateSelectedHeight}
            min={marksHeight[0].value}
            max={marksHeight[marksHeight.length - 1].value}
            marks={marksHeight}
            allShelves={shelvesCabinet.length === shelvesSelected.length}
            shelvesSelected={shelvesSelected}
          />
        );
      case 'action':
        return <ActionShelfRibbonSection shelf={shelvesSelected[0]} />;
      case 'composition':
        return <ShelfCompositionSelector />;
      case 'doors':
        return <ColorsMobilePanel showDoors />;
      case 'handles':
        return <HandlesPanel />;
      case 'sides':
        return <ColorsMobilePanel />;
      case 'plate':
        return <PlatePanel />;
      case 'drawers':
        return <DrawersPanel />;
      case 'intermediatesShelves':
        return <IntermediateShelfPanel />;
      default:
        return null;
    }
  }

  return (
    <div className="flex flex-col w-full">
      <MobileMenu
        initialSelection={isMobileMenuOpen ? 'height' : null}
        list={list}
        cabinetEdit={cabinetEdit}
        panelOpen={mobilePanelOpen !== undefined}
        multiShelfSelected={
          shelvesCabinet.length > 1 && shelvesSelected.length > 1
        }
      />
    </div>
  );
}

export default MobileMenuShelves;
